module.exports = __webpack_public_path__ + "media/images/testimonial-swimming-safari-813051d29775547b9cb8875da188114c.png";